
import axios from "axios";
export const getSessionId = (userId, org) => {
  return axios.post(`${process.env.REACT_APP_API_SERVICE}analytics/session/`, {}, {
    params: {
      visitor: userId,
      identifier: org,
    }
  });
}

export const sendEvent = (sessionId, eventName, event) => {
  return axios.post(`${process.env.REACT_APP_API_SERVICE}analytics/getdetails/`, event, {
    params: {
      session: sessionId,
      name: eventName,
    }
  });
}